import * as React from 'react';
import {Route} from 'react-router-dom';

import {ListPageWrapper} from '../../routes/utils';

export type Props = {
    path: string;
    localStorageKey: string;
    defaultQuery: string;
    ignoreUnknownParams?: boolean;
    includeHash?: boolean;
    component: React.ComponentType<any>;
};

export const ListPageRoute = (props: Props) => (
    <Route
        path={props.path}
        render={(routeProps) => {
            const Component = props.component;

            return (
                <ListPageWrapper
                    routeProps={routeProps}
                    localStorageKey={props.localStorageKey}
                    defaultQuery={props.defaultQuery}
                    ignoreUnknownParams={props.ignoreUnknownParams}
                    includeHash={props.includeHash}
                >
                    {({
                        activeFilters,
                        urlParams,
                        onParamChange,
                        getUpdatedUrl,
                        onUpdateFilters,
                        onRemoveAllFilters,
                    }) => (
                        <Component
                            {...routeProps}
                            activeFilters={activeFilters}
                            urlParams={urlParams}
                            onParamChange={onParamChange}
                            getUpdatedUrl={getUpdatedUrl}
                            onUpdateFilters={onUpdateFilters}
                            onRemoveAllFilters={onRemoveAllFilters}
                        />
                    )}
                </ListPageWrapper>
            );
        }}
    />
);
